"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Logo = function Logo(props) {
  var classes = (0, _classnames["default"])("logo-component", props.className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: props.url,
    style: {
      paddingLeft: props.padding
    },
    width: props.width,
    height: props.height,
    alt: props.alt
  }));
};

Logo.propTypes = {
  url: _propTypes["default"].string,
  padding: _propTypes["default"].string,
  className: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  alt: _propTypes["default"].string
};
Logo.defaultProps = {
  url: "",
  className: "",
  padding: ""
};
var _default = Logo;
exports["default"] = _default;